/**
 * Depending on the device the mimetype has to be different.
 * Browser needs webm, and ios needs mp4.
 */
export function getSupportedMimeType(): string {
  let options = '';
  if (MediaRecorder.isTypeSupported('video/mp4')) {
    options = 'video/mp4';
  } else if (MediaRecorder.isTypeSupported('video/webm; codecs=vp9')) {
    options = 'video/webm; codecs=vp9';
  } else if (MediaRecorder.isTypeSupported('video/webm')) {
    options = 'video/webm';
  } else {
    console.error('no suitable mimetype found for this device');
  }

  return options;
}
